<template>
  <div>
    <div class="flex items-end">
      <fund-selector @fund-selected="onFundSelected($event)" />
      <a-button
        class="ml-2"
        type="primary"
        @click="addReport()"
        :disabled="!selectedFund"
      >
        Add report
      </a-button>
    </div>
    <fund-reports-list
      v-if="selectedFund"
      ref="reportsList"
      :fundId="selectedFund.key"
      @showReport="showReport($event)"
      @editReport="editReport($event)"
      @deleteReport="deleteReport($event)"
    />

    <a-drawer
      :title="reportDrawerTitle"
      width="600"
      placement="right"
      :visible="showReportDrawer"
      @close="onReportDrawerClosed()"
    >
      <fund-monthly-report v-if="selectedReport" :report="selectedReport" />
    </a-drawer>

    <a-drawer
      title="Add Monthly Report"
      width="600"
      placement="right"
      :visible="showAddReportDrawer"
      @close="onAddReportDrawerClosed()"
    >
      <add-fund-monthly-report
        :fund="selectedFund"
        :classes="selectedFundClasses"
        @reportSaved="onReportAdded($event)"
        @cancelButtonClicked="showAddReportDrawer = false"
      />
    </a-drawer>
    <a-drawer
      :title="reportDrawerTitle"
      width="600"
      placement="right"
      :visible="showEditReportDrawer"
      @close="onEditReportDrawerClosed()"
    >
      <edit-fund-monthly-report
        v-if="selectedReport"
        :report="selectedReport"
        @reportSaved="onReportUpdated($event)"
        @cancelButtonClicked="showEditReportDrawer = false"
      />
    </a-drawer>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import AddFundMonthlyReport from '../components/FundReporting/AddFundMonthlyReport.vue'
import EditFundMonthlyReport from '../components/FundReporting/EditFundMonthlyReport.vue'
import FundReportsList from '../components/FundReporting/FundReportsList.vue'
import FundMonthlyReport from '../components/FundReporting/FundMonthlyReport.vue'
import FundSelector from '../components/FundReporting/FundSelector.vue'

export default {
  components: {
    AddFundMonthlyReport,
    EditFundMonthlyReport,
    FundReportsList,
    FundMonthlyReport,
    FundSelector,
  },
  apollo: {
    funds: {
      client: 'funds',
      query: gql`
        query {
          funds {
            id
            key
            name
            currency
          }
        }
      `,
    },
  },
  data() {
    return {
      funds: [],
      selectedFund: null,
      selectedFundClasses: [],
      selectedReport: null,
      showReportDrawer: false,
      showAddReportDrawer: false,
      showEditReportDrawer: false,
    }
  },
  computed: {
    reportDrawerTitle() {
      if (!this.selectedReport) {
        return ''
      }
      if (!this.selectedFund) {
        return ''
      }
      return `${this.selectedFund.name} - ${this.selectedReport.year}/${this.selectedReport.month}`
    },
  },
  methods: {
    onFundSelected(payload) {
      this.selectedFund = payload.fund
      this.selectedFundClasses = payload.classes
    },
    showReport(report) {
      this.selectedReport = report
      this.showReportDrawer = true
    },
    editReport(report) {
      this.selectedReport = report
      this.showEditReportDrawer = true
    },
    onReportDrawerClosed() {
      this.showReportDrawer = false
    },
    addReport() {
      this.showAddReportDrawer = true
    },
    async deleteReport({ fundId, year, month }) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($input: DeleteFundMonthlyReportInput) {
            deleteFundMonthlyReport(input: $input) {
              reportId
            }
          }
        `,
        variables: {
          input: {
            fundId,
            year,
            month,
          },
        },
      })
      this.$refs.reportsList.reloadReports()
    },
    onAddReportDrawerClosed() {
      this.showAddReportDrawer = false
    },
    onEditReportDrawerClosed() {
      this.showEditReportDrawer = false
    },
    onReportAdded() {
      this.showAddReportDrawer = false
      this.$refs.reportsList.reloadReports()
    },
    onReportUpdated() {
      this.showEditReportDrawer = false
      this.$refs.reportsList.reloadReports()
    },
  },
}
</script>

<style></style>
